import React from "react";
import SearchField from "Components/Fragment/SearchField";

const InputTextSearch = ({
  searchText,
  setSearchText,
  onSearch,
  languageContext,
}) => {
  return (
    <SearchField
      value={searchText}
      ariaLabel={languageContext("searchinmylearning")}
      placeholder={languageContext("search")}
      clearLabel={languageContext("clearSearch")}
      searchLabel={languageContext("search")}
      onChange={(e) => setSearchText(e.target.value)}
      onSearch={onSearch}
      onClear={() => setSearchText("")}
      onBlur={onSearch}
      searchMode="onSubmit"
      sx={{ width: "250px", maxWidth: "250px !important" }}
    />
  );
};

export default InputTextSearch;
